var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowCircleRightFill = function SvgArrowCircleRightFill(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "m13 15.5 2.5-2.6a1.3 1.3 0 0 0 0-1.8L13 8.4q-.3-.3-.9-.3a1.3 1.3 0 0 0-1.3 1.3c0 .4.1.7.4 1l.3.3H9c-.4 0-.7.1-1 .4q-.3.3-.3.9c0 .6.1.7.4 1q.3.3.9.3h2.4l-.3.4c-.3.2-.4.5-.4.9a1.3 1.3 0 0 0 1.3 1.3c.4 0 .7-.1 1-.4m-1 7.3a10.5 10.5 0 0 1-7.6-3.2A11 11 0 0 1 1.2 12a10.6 10.6 0 0 1 3.2-7.7A10.8 10.8 0 0 1 16.2 2 10.7 10.7 0 0 1 22 16.2a10.8 10.8 0 0 1-10 6.6"
  })));
};
export default SvgArrowCircleRightFill;